const re = /^(?!00[^0])0/;
export default function phoneNumberFormat(phoneNumber) {
  return phoneNumber ? phoneNumber.replace(re, '') : '';
}
